module.exports = __webpack_public_path__ + "lang/cs.json";


//////////////////
// WEBPACK FOOTER
// ./lang/cs.json
// module id = 77
// module chunks = d-game